import React, { useState, useCallback, useContext } from 'react';
import NumberBlock from '../../form/blocks/NumberBlock';
import axios from 'axios';
import { config } from '../../../utils/config';
import AuthContext from '../../authcontext/AuthContext';

export default function BiddingConsole({ id, onNewBid }) {

  const authData = useContext(AuthContext);
  const [offerBid, setOfferBid] = useState(0)

  const submitBid = useCallback(async () => {

    const bidToken = authData.getClientToken()
    const response = await axios.post(`${config.apiBaseUrl}/bidsession/placebid`, {
      bidId: id,
      bidPrice: offerBid,
      bidToken: bidToken
    }, {
      withCredentials: true
    })

    console.log(response.data)

    onNewBid()

  }, [id, onNewBid, authData, offerBid])




  return (
    <>
      <div>
        <NumberBlock label={"Offer Bid"}
          updateParentValue={(value) => setOfferBid(value)} prefix={"$"} suffix={""} />

        <button className='btn btn-danger' onClick={() => { submitBid() }}>
          submit

        </button>

      </div>





    </>
  )
}
